import { render, staticRenderFns } from "./tagsView.vue?vue&type=template&id=ca8dfad2&scoped=true"
import script from "./tagsView.vue?vue&type=script&lang=js"
export * from "./tagsView.vue?vue&type=script&lang=js"
import style0 from "./tagsView.vue?vue&type=style&index=0&id=ca8dfad2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8dfad2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\fenxijunya-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca8dfad2')) {
      api.createRecord('ca8dfad2', component.options)
    } else {
      api.reload('ca8dfad2', component.options)
    }
    module.hot.accept("./tagsView.vue?vue&type=template&id=ca8dfad2&scoped=true", function () {
      api.rerender('ca8dfad2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/navBars/tagsView/tagsView.vue"
export default component.exports